import { IconsEnum } from '@components/icons/types';
import { ReactNode } from 'react';
import * as Styles from '@screens/lp-default/components/plans/card/styles';
import Icon from '@components/icons';
import { OffersModel } from '@remote-data/load-offers/types';

type PlanCardProp = {
  title: string;
  icon: IconsEnum;
  description: string;
  buttonText: string;
  buttonClick(): void;
  benefits: ReactNode;
  offers: OffersModel;
  isHighlighted?: boolean;
  tag?: string;
  showOffers?: boolean;
};

export default function PlanCard({
  title,
  icon,
  description,
  buttonText,
  buttonClick,
  benefits,
  offers,
  isHighlighted,
  tag,
  showOffers,
}: PlanCardProp) {
  const getDiscountedTotal = () => {
    const annualPlan = offers?.planList.find((plan) => plan.splittable === false && plan.period === 'annually');
    return annualPlan.price.total;
  };

  return (
    <Styles.PlanCard isHighlighted={isHighlighted}>
      <Styles.PlanCardMain>
        {tag && <Styles.PlanCardTag>{tag}</Styles.PlanCardTag>}
        <Styles.PlanCardIcon>
          <Icon icon={icon} size={32} />
        </Styles.PlanCardIcon>
        <Styles.PlanCardTitle>{title}</Styles.PlanCardTitle>
        <Styles.PlanCardDescription>{description}</Styles.PlanCardDescription>
      </Styles.PlanCardMain>
      {showOffers && offers && (
        <>
          <Styles.PlanPriceContent>
            <Styles.PlanPrice>
              R$ <Styles.PlanPriceValue>{offers?.basePrice?.monthly}</Styles.PlanPriceValue> /mês
            </Styles.PlanPrice>
            <Styles.PlanPriceDivisor />
            <Styles.PlanPrice>
              R$ <Styles.PlanPriceValue>{getDiscountedTotal()}*</Styles.PlanPriceValue> /ano
            </Styles.PlanPrice>
          </Styles.PlanPriceContent>
          <Styles.PlanPriceNote>*Preço à vista ou R$ {offers?.basePrice?.annually} até 12x</Styles.PlanPriceNote>
        </>
      )}
      <Styles.PlanCardButton onClick={buttonClick} isHighlighted={isHighlighted}>
        {buttonText}
      </Styles.PlanCardButton>
      <Styles.PlanCardDivisor />
      {benefits}
    </Styles.PlanCard>
  );
}
